import {IBaseEntity, BaseEntity} from 'app/blocks/model/base-entity.model';
import {IShippingLineLocationPoint, ShippingLineLocationPoint} from 'app/blocks/model/shipping-line-location-point.model';
import {IUser, User} from 'app/core/user/user.model';
import {DiTime} from 'app/blocks/util/di-time';

export interface IShippingLine extends IBaseEntity {
    id?: number;
    name?: string;
    description?: string;
    cost?: number;
    shippingType?: string;
    bookingType?: string;
    departureTime?: string | DiTime;
    durationMinutes?: number;
    shipsFrom?: string;
    shipsTo?: string;
    routeCode?: string;
    customsStatus?: string;
    ukBorderProcess?: string;
    locationPoints?: IShippingLineLocationPoint[];
    expenseTypeIds?: number[];
}

export class ShippingLine extends BaseEntity implements IShippingLine {
    public id?: number;
    public name?: string;
    public description?: string;
    public cost?: number;
    public shippingType?: string;
    public bookingType?: string;
    public departureTime?: string | DiTime;
    public durationMinutes?: number;
    public shipsFrom?: string;
    public shipsTo?: string;
    public routeCode?: string;
    public customsStatus?: string;
    public ukBorderProcess?: string;
    public locationPoints?: IShippingLineLocationPoint[];
    public expenseTypeIds?: number[];

    constructor(shippingLine?) {
        super();
        if (shippingLine) {
            this.id = shippingLine.id;
            this.name = shippingLine.name;
            this.description = shippingLine.description;
            this.cost = shippingLine.cost;
            this.shippingType = shippingLine.shippingType;
            this.bookingType = shippingLine.bookingType;
            this.departureTime = shippingLine.departureTime;
            this.durationMinutes = shippingLine.durationMinutes;
            this.shipsFrom = shippingLine.shipsFrom;
            this.shipsTo = shippingLine.shipsTo;
            this.routeCode = shippingLine.routeCode;
            this.customsStatus = shippingLine.customsStatus;
            this.ukBorderProcess = shippingLine.ukBorderProcess;
            this.locationPoints = shippingLine.locationPoints ? shippingLine.locationPoints.map((lp) => new ShippingLineLocationPoint(lp)) : [];
            this.expenseTypeIds = shippingLine.expenseTypeIds;
        } else {
            this.locationPoints = [];
            this.expenseTypeIds = [];
        }
    }

    get discriminator(): any {
        return this.name;
    }

    clone(): IShippingLine {
        return new ShippingLine(this);
    }
}
